import { KeyCodeTypes } from 'common/interfaces';

class KeyboardService {
  checkIfPressedOneKeyOf(pressedKeys: string[], keys: KeyCodeTypes[]): boolean {
    for (const key of keys) {
      if (pressedKeys.includes(key)) return true;
    }
    return false;
  }

  checkIfPressedAllKeys(pressedKeys: string[], keys: KeyCodeTypes[]): boolean {
    for (const key of keys) {
      if (!pressedKeys.includes(key)) return false;
    }
    return true;
  }
}

export default new KeyboardService();
